import { Checkbox } from "antd";
import React, { useState } from "react";
import { redCrossIcon, TickIcon } from "../../../../../assets/svg";
import CustomButton from "../../../../../components/customButton";
import CommonInput from "../../../../../components/commonFields";
import {
  DeleteIcon,
  EditIconDark,
  PreviewEyeIcon,
} from "../../../../../assets/svg/mobileIcon";

const SelectFileMob = (props) => {
  const [fileValue, setFile] = useState(null);
  const [editMode, setEditMode] = useState(null);

  const onChange = (event, file) => {
    if (event.target.checked) {
      setFile(file);
      props.handleSelect(file);
    } else {
      setFile(null);
      props.handleSelect(null);
    }
  };

  const openEditMode = (file) => {
    setEditMode(file.customFileId);
  };

  const closeEditMode = () => {
    setEditMode(null);
  };

  const fileDiv = props.savedFiles.map((file) => {
    return (
      <div className="row-flex" key={file.customFileId}>
        {editMode !== file.customFileId && (
          <>
            <div className="radio-container">
              <Checkbox
                onChange={(event) => {
                  onChange(event, file);
                }}
                disabled={
                  fileValue && fileValue?.customFileId !== file.customFileId
                }
              >
                {file.fileNickName}
              </Checkbox>
            </div>
            {props.editDeleteAccess !== 0 && (
              <div className="sm-icon">
                <span
                  onClick={() => {
                    props.handleDelete(file);
                  }}
                >
                  <DeleteIcon />
                </span>
              </div>
            )}
            {props.editDeleteAccess !== 0 && (
              <div className="sm-icon">
                <span
                  onClick={() => {
                    openEditMode(file);
                  }}
                >
                  <EditIconDark />
                </span>
              </div>
            )}
            <div className="sm-icon">
              <span
                onClick={() => {
                  props.handlePreview(file);
                }}
              >
                <PreviewEyeIcon />
              </span>
            </div>
          </>
        )}
        {editMode === file.customFileId && (
          <>
            <div className="radio-container">
              <CommonInput
                placeholder="New Custom File Name"
                onChange={props.handleOnChange}
                defaultValue={file.fileNickName}
              />
            </div>
            <div className="sm-icon select-file-actions">
              <CustomButton
                btntype="clear"
                className="ml-8 cancel-button"
                onClick={closeEditMode}
                title={redCrossIcon}
              />
            </div>
            <div className="sm-icon select-file-actions">
              <CustomButton
                btntype="clear"
                className="ml-8 cancel-button"
                onClick={() => {
                  props.handleSave(file);
                }}
                title={<TickIcon />}
              />
            </div>
          </>
        )}
      </div>
    );
  });

  return <div className="recent-files">{fileDiv}</div>;
};

export default SelectFileMob;
